import styled, { css } from 'styled-components';
// eslint-disable-next-line no-restricted-syntax
export const visuallyHiddenStyles = css `
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  width: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  word-wrap: normal;
`;
export const Container = styled.span `
  ${visuallyHiddenStyles};
`;
